import React from "react"
import { AiFillDelete } from "react-icons/ai"
import { VscDebugStart } from "react-icons/vsc"
import { FaCheck } from "react-icons/fa"
import { IoCloseSharp } from "react-icons/io5"
import { SiCodefactor } from "react-icons/si"
import { TbTransferOut } from "react-icons/tb"
import { RiSwapBoxLine } from "react-icons/ri"

import { v4 as uuidv4 } from "uuid"

const layoutTypes = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
}

const buttonColor = {
  Aprobar: "success",
  Rechazar: "danger",
}

const actionIcons = {
  1: <VscDebugStart color="#0079db" className="ms-n1" size={24} />, // iniciar

  25: <FaCheck color="green" size={18} />, // aprobar
  26: <IoCloseSharp color="red" size={26} />, // rechazar

  101: <FaCheck color="green" size={18} />, // aprobar
  102: <IoCloseSharp color="red" size={26} />, // rechazar
  103: <AiFillDelete color="#737373" size={20} />, // descartar

  111: <FaCheck color="green" size={18} />, // aprobar
  112: <IoCloseSharp color="red" size={26} />, // rechazar
  113: <AiFillDelete color="#737373" size={20} />, // descartar
  114: <TbTransferOut color="#737373" size={20} />, // devolver a oficial

  201: <FaCheck color="green" size={18} />, // aprobar
  202: <IoCloseSharp color="red" size={26} />, // rechazar
  203: <AiFillDelete color="#737373" size={20} />, // descartar
  204: <TbTransferOut color="#737373" size={20} />, // devolver a comercial

  301: <FaCheck color="green" size={18} />, // aprobar
  302: <IoCloseSharp color="red" size={26} />, // rechazar
  303: <AiFillDelete color="#737373" size={20} />, // descartar
  304: <TbTransferOut color="#737373" size={20} />, // devolver a comercial
  305: <SiCodefactor color="#737373" />, // devolver a revisar

  501: <FaCheck color="green" size={18} />, // aprobar
  502: <IoCloseSharp color="red" size={26} />, // rechazar
  503: <AiFillDelete color="#737373" size={20} />, // descartar
  504: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  511: <FaCheck color="green" size={18} />, // aprobar
  512: <IoCloseSharp color="red" size={26} />, // rechazar
  513: <AiFillDelete color="#737373" size={20} />, // descartar
  514: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  521: <FaCheck color="green" size={18} />, // aprobar
  522: <IoCloseSharp color="red" size={26} />, // rechazar
  523: <AiFillDelete color="#737373" size={20} />, // descartar
  524: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  531: <FaCheck color="green" size={18} />, // aprobar
  532: <IoCloseSharp color="red" size={26} />, // rechazar
  533: <AiFillDelete color="#737373" size={20} />, // descartar
  534: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  541: <FaCheck color="green" size={18} />, // aprobar
  542: <IoCloseSharp color="red" size={26} />, // rechazar
  543: <AiFillDelete color="#737373" size={20} />, // descartar
  544: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  611: <FaCheck color="green" size={18} />, // aprobar
  612: <IoCloseSharp color="red" size={26} />, // rechazar
  613: <AiFillDelete color="#737373" size={20} />, // descartar
  614: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  621: <FaCheck color="green" size={18} />, // aprobar
  622: <IoCloseSharp color="red" size={26} />, // rechazar
  623: <AiFillDelete color="#737373" size={20} />, // descartar
  624: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  711: <FaCheck color="green" size={18} />, // aprobar
  712: <IoCloseSharp color="red" size={26} />, // rechazar
  713: <AiFillDelete color="#737373" size={20} />, // descartar
  714: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  721: <FaCheck color="green" size={18} />, // aprobar
  722: <IoCloseSharp color="red" size={26} />, // rechazar
  723: <AiFillDelete color="#737373" size={20} />, // descartar
  724: <RiSwapBoxLine color="#737373" size={20} />, // devolver a riesgo

  901: <FaCheck color="green" size={18} />, // continuar
  902: <IoCloseSharp color="red" size={26} />, // cerrar
  911: <FaCheck color="green" size={18} />, // continuar
  912: <IoCloseSharp color="red" size={26} />, // cerrar
  921: <FaCheck color="green" size={18} />, // continuar
  922: <IoCloseSharp color="red" size={26} />, // cerrar
  //922: <RiSwapBoxLine color="#737373" size={20} />, // cerrar

  20011: <VscDebugStart color="#0079db" className="ms-n1" size={24} />,
  20801: <VscDebugStart color="#0079db" className="ms-n1" size={24} />,
  20851: <VscDebugStart color="#0079db" className="ms-n1" size={24} />,
  20901: <FaCheck color="green" size={18} />,
  20911: <FaCheck color="green" size={18} />,
  20912: <IoCloseSharp color="red" size={26} />,
  20921: <FaCheck color="green" size={18} />,
  20922: <IoCloseSharp color="red" size={26} />,
  20931: <FaCheck color="green" size={18} />,
  20932: <IoCloseSharp color="red" size={26} />,

  default: <SiCodefactor />,
}

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  border: "2px",
  boxShadow: 24,
  maxHeight: 650,
  overflowY: "auto",
  p: 4,
  // borderRadius: "15px",
}

const cupoLimite = [
  {
    id: 0,
    codigo: 0,
    tipo: "CUPO",
    descripcion: "Cupo Cliente",
    fechaVencimiento: null,
    identacion: 0,
    orden: 1,
    detalle: {
      calificacionAnterior: {
        moneda: "80",
        monto: null,
        editable: true,
      },
      deuda: null,
      disponible: null,
      calificacionNueva: {
        moneda: "80",
        monto: null,
        editable: true,
      },
      riesgoNuevo: null,
      cotizacionBcra: 1,
      exclusion: null,
      tipoGarantia: null,
      descripcionGarantia: null,
    },
    codigoLimite: null,
    descripcionLimite: null,
    datosAdicionales: null,
  },
]

const checklistItems = [
  {
    id: 0,
    codigo: "",
    item: {
      codigo: "",
      descripcion: "",
    },
    estado: "",
    usrAlta: null,
    usrModif: null,
    falta: new Date(),
    fmodif: new Date(),
  },
]

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#eff2f7",
      fontWeight: 600,
      fontSize: 13,
      color: "#495057",
    },
  },
}

const layoutWidthTypes = {
  FLUID: "fluid",
  BOXED: "boxed",
  SCROLLABLE: "scrollable",
}

const topBarThemeTypes = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored",
}

const leftBarThemeImageTypes = {
  NONE: "none",
  IMG1: "img1",
  IMG2: "img2",
  IMG3: "img3",
  IMG4: "img4",
}

const leftSidebarTypes = {
  DEFAULT: "default",
  COMPACT: "compact",
  ICON: "icon",
}

const leftSideBarThemeTypes = {
  LIGHT: "light",
  COLORED: "colored",
  DARK: "dark",
  WINTER: "winter",
  LADYLIP: "ladylip",
  PLUMPLATE: "plumplate",
  STRONGBLISS: "strongbliss",
  GREATWHALE: "greatwhale",
}

export const createObject = (
  dsc,
  identificador,
  ordenDflt,
  clasificacion,
  identacion,
  importe,
) => {
  return {
    id: uuidv4(),
    codCuenta: 1,
    importe: importe,
    usrAlta: null,
    usrModif: null,
    varVertical: 0,
    varHorizontal: 0,
    cuentaContable: {
      cod: 1,
      asociaImporteDflt: "N",
      calculadoDflt: "N",
      clasificacion: clasificacion,
      dsc: dsc,
      identificador: identificador,
      indentacionDflt: identacion,
      ordenDflt: ordenDflt,
      signoDflt: "*",
      subclasificacion: 0,
      sumandosDflt: "",
      usrAlta: "DN,",
      usrModif: null,
      falta: null,
      fmodif: null,
    },
    falta: "test",
    fmodif: null,
  }
}

export {
  layoutTypes,
  buttonColor,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
  customStyles,
  actionIcons,
  cupoLimite,
  checklistItems,
  modalStyle,
}
